import { getLocale } from "@sia/style-guide";
const lang = getLocale(sessionStorage.getItem("sia.benchmarking.languageKey"));

/**
 * Interpolates a URL with given parameters specifically for Datahouse API
 */
export const interpolateURL = (params) => {
  const { apiUrl, endpoint, id, omitLanguage } = params;
  let idWithSlash = id ? "/" + id : "";
  let result = apiUrl + "/" + endpoint + idWithSlash;

  if (omitLanguage) return result;
  return result + "/" + (lang || "de_DE");
};
